module.exports = __webpack_public_path__ + "static/media/launch.787ddb04.svg";